/* eslint-disable import/prefer-default-export */
export const ActionTypes = {
  UPDATE_BANNER: 'UPDATE_BANNER',
  UPDATE_RUN_SEQUENCE: 'UPDATE_RUN_SEQUENCE',
  UPDATE_CONSOLE_LOG_RUN_SEQUENCES: 'UPDATE_CONSOLE_LOG_RUN_SEQUENCES',
  TOGGLE_CONSOLE_LOG: 'TOGGEL_CONSOLE_LOG',
  SET_CONSOLE_LOG_VALUE: 'SET_CONSOLE_LOG_VALUE',
  TOGGLE_CHECKOUT_FORM: 'TOGGLE_CHECKOUT_FORM',
  TOGGLE_START_OVER_CALLOUT: 'TOGGLE_START_OVER_CALLOUT',
  DETAILS_PATH: 'DETAILS_PATH',
  SHOW_GIF: 'SHOW_GIF',
  UPDATE_CURRENT_STAGE: 'UPDATE_CURRENT_STAGE',
  UPDATE_IS_CHALLENGE_CARD_CHOOSED: 'UPDATE_IS_CHALLENGE_CARD_CHOOSED'
};
